import L from "leaflet";

import "leaflet.heat";

import "leaflet/dist/leaflet.css";

import { MapContainer, TileLayer, useMap } from "react-leaflet";

import React from "react";

const DEFAULT_CENTER = [-14.235004, -51.92528];
const DEFAULT_ZOOM = 4;

const coordinatesByLocation = {
    AC: [-8.77, -70.55],
    AL: [-9.71, -35.73],
    AM: [-3.07, -61.66],
    AP: [1.41, -51.77],
    BA: [-12.96, -38.51],
    CE: [-3.71, -38.54],
    DF: [-15.83, -47.86],
    ES: [-19.19, -40.34],
    GO: [-16.64, -49.31],
    MA: [-2.55, -44.3],
    MG: [-18.1, -44.38],
    MS: [-20.51, -54.54],
    MT: [-12.64, -55.42],
    PA: [-5.53, -52.29],
    PB: [-7.06, -35.55],
    PE: [-8.28, -35.07],
    PI: [-8.28, -43.68],
    PR: [-24.89, -51.55],
    RJ: [-22.84, -43.15],
    RN: [-5.22, -36.52],
    RO: [-11.22, -62.8],
    RR: [1.89, -61.22],
    RS: [-30.01, -51.22],
    SC: [-27.33, -49.44],
    SE: [-10.9, -37.07],
    SP: [-23.55, -46.64],
    TO: [-10.25, -48.25],
    ARGENTINA: [-38.4161, -63.6167],
    BOLIVIA: [-16.2902, -63.5887],
    BOLIVIA_PLURINATIONAL_STATE_OF: [-16.2902, -63.5887],
    BRASIL: [-14.235004, -51.92528],
    BRAZIL: [-14.235004, -51.92528],
    CHILE: [-35.6751, -71.543],
    COLOMBIA: [4.5709, -74.2973],
    COSTA_RICA: [9.7489, -83.7534],
    CUBA: [21.5218, -77.7812],
    DOMINICAN_REPUBLIC: [18.7357, -70.1627],
    ECUADOR: [-1.8312, -78.1834],
    EL_SALVADOR: [13.7942, -88.8965],
    GUATEMALA: [15.7835, -90.2308],
    HONDURAS: [15.2, -86.2419],
    MEXICO: [23.6345, -102.5528],
    NICARAGUA: [12.8654, -85.2072],
    PANAMA: [8.538, -80.7821],
    PARAGUAY: [-23.4425, -58.4438],
    PERU: [-9.19, -75.0152],
    PUERTO_RICO: [18.2208, -66.5901],
    URUGUAY: [-32.5228, -55.7658],
    VENEZUELA: [6.4238, -66.5897],
};

const normalizeLocationKey = (value = "") =>
    value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s]/g, " ")
        .trim()
        .replace(/\s+/g, "_")
        .toUpperCase();

const getCoordinates = (location) => {
    const normalizedLocation = normalizeLocationKey(location);

    return coordinatesByLocation[normalizedLocation] || null;
};

const Heatmap = ({ points }) => {
    const map = useMap();

    React.useEffect(() => {
        const heatLayer = L.heatLayer(points, {
            radius: 20,
            blur: 15,
            maxZoom: 2,
            gradient: {
                0.2: "blue",
                0.4: "lime",
                0.6: "yellow",
                0.8: "orange",
                1: "red",
            },
        }).addTo(map);

        if (points.length > 0) {
            const bounds = L.latLngBounds(points.map(([lat, lng]) => [lat, lng]));
            map.fitBounds(bounds, { padding: [30, 30] });
        } else {
            map.setView(DEFAULT_CENTER, DEFAULT_ZOOM);
        }

        return () => {
            map.removeLayer(heatLayer);
        };
    }, [map, points]);

    return null;
};

const HeatmapExample = ({ normasPorEsfera }) => {
    const populationData = normasPorEsfera
        .map((esfera) => {
            const coords = getCoordinates(esfera.estado);

            return coords ? [...coords, esfera.porcentagem / 100 + 0.5] : null;
        })
        .filter(Boolean);

    return (
        <MapContainer
            center={DEFAULT_CENTER}
            zoom={DEFAULT_ZOOM}
            style={{ height: "100%", width: "100%" }}
        >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

            <Heatmap points={populationData} />
        </MapContainer>
    );
};

export default HeatmapExample;
